export enum IdentityAccessRights {
  IdentityReset = 'IDENTITY_RESET',
  MakeAdmin = 'ORG_USER_CHANGE_ADMIN',
  UpgradeUser = 'USER_UPGRADE',
}
